import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://frsnqhegcypvoydcdixr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZyc25xaGVnY3lwdm95ZGNkaXhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3MTI4ODksImV4cCI6MjA3MTI4ODg4OX0.A5rF8ZOpdSzPI4A64FUtKyVYYb1Y7Leam6tuXyiDuRA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

































